import { call, delay, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import axiosApi from "../../utils/axios";
import {
  RequestDeployInt,
  SuccessDeployInt,
  FailureDeployInt,
  RequestGetConfig,
  SuccessGetConfig,
  FailureGetConfig,
  RequestDeleteInt,
  SuccessDeleteInt,
  FailureDeleteInt,
  RequestSetConfig,
  SuccessSetConfig,
  FailureSetConfig,
  RequestResetConfig,
  SuccessResetConfig,
  FailureResetConfig,
  RequestTogglePhishboxLlm,
  SuccessTogglePhishboxLlm,
  FailureTogglePhishboxLlm,
  RequestCheckConfig,
  SuccessCheckConfig,
  FailureCheckConfig,
  RequestDeleteConfig,
  SuccessDeleteConfig,
  FailureDeleteConfig,
  RequestUpdateConfig,
  SuccessUpdateConfig,
  FailureUpdateConfig,
  RequestAgentStatus,
  SuccessAgentStatus,
  FailureAgentStatus,
  RequestAgentInstallationList,
  SuccessAgentInstallationList,
  FailureAgentInstallationList,
  // RequestAllAgentsThreatHunter,
  // SuccessAllAgentsThreatHunter,
  // FaliureAllAgentsThreatHunter,
  RequestSingleAgentDataThunter,
  SuccessSingleAgentDataThunter,
  FaliureSingleAgentDataThunter,
  RequestCreateNewAgent,
  SuccessCreateNewAgent,
  FailureCreateNewAgent,
  RequestAnalyzeAgent,
  SuccessAnalyzeAgent,
  FailureAnalyzeAgent,
  RequestYaraScanAgent,
  SuccessYaraScanAgent,
  FailureYaraScanAgent,
  RequestAgentAnalysisData,
  SuccessAgentAnalysisData,
  FailureAgentAnalysisData,
  RequestAgentSigmaOutput,
  SuccessAgentSigmaOutput,
  FailureAgentSigmaOutput,
  RequestAgentProcessSnapshot,
  SuccessAgentProcessSnapshot,
  FailureAgentProcessSnapshot,
  RequestSingleAgentIocResults,
  SuccessSingleAgentIocResults,
  FailureSingleAgentIocResults,
  RequestUpdateAgentDescription,
  SuccessUpdateAgentDescription,
  FailureUpdateAgentDescription,
  RequestDeleteAgentRecord,
  SuccessDeleteAgentRecord,
  FailureDeleteAgentRecord,
  RequestAgentGroups,
  SuccessAgentGroups,
  FailureAgentGroups,
  RequestAllAgentGroups,
  SuccessAllAgentGroups,
  FailureAllAgentGroups,
  RequestBulkAnalyzeAgents,
  SuccessBulkAnalyzeAgents,
  FailureBulkAnalyzeAgents,
  RequestBulkYaraScanAgents,
  SuccessBulkYaraScanAgents,
  FailureBulkYaraScanAgents,
  RequestBulkDeleteAgents,
  SuccessBulkDeleteAgents,
  FailureBulkDeleteAgents,
  RequestCreateAgentGroup,
  SuccessCreateAgentGroup,
  FailureCreateAgentGroup,
  RequestDeleteAgentGroup,
  SuccessDeleteAgentGroup,
  FailureDeleteAgentGroup,
  RequestAgentPolicies,
  SuccessAgentPolicies,
  FailureAgentPolicies,
  RequestCreateAgentPolicy,
  SuccessCreateAgentPolicy,
  FailureCreateAgentPolicy,
  RequestAgentPolicy,
  SuccessAgentPolicy,
  FailureAgentPolicy,
  RequestMoveAgentPolicy,
  SuccessMoveAgentPolicy,
  FailureMoveAgentPolicy,
  RequestUpdateAgentPolicy,
  SuccessUpdateAgentPolicy,
  FailureUpdateAgentPolicy,
  RequestDeleteAgentPolicy,
  SuccessDeleteAgentPolicy,
  FailureDeleteAgentPolicy,
  RequestResetAgentPolicy,
  SuccessResetAgentPolicy,
  FailureResetAgentPolicy,
  RequestRepairAgentPolicy,
  SuccessRepairAgentPolicy,
  FailureRepairAgentPolicy,
  RequestDistinctLiveThreatHunters,
  SuccessDistinctLiveThreatHunters,
  FailureDistinctLiveThreatHunters,
  RequestTapInterfaces,
  SuccessTapInterfaces,
  FailureTapInterfaces,
  RequestHunterBoxList,
  SuccessHunterBoxList,
  FailureHunterBoxList,
  RequestYaraResultsList,
  SuccessYaraResultsList,
  FailureYaraResultsList,
  RequestHunterBoxStats,
  SuccessHunterBoxStats,
  FailureHunterBoxStats,
  RequestThreatHunterDashboard,
  SuccessThreatHunterDashboard,
  FailureThreatHunterDashboard,
  RequestThreatHunterSubmit,
  SuccessThreatHunterSubmit,
  FailureThreatHunterSubmit,
  RequestGenerateAgentAIDecision,
  SuccessGenerateAgentAIDecision,
  FailureGenerateAgentAIDecision,
  RequestGetAgentAIDecision,
  SuccessGetAgentAIDecision,
  FailureGetAgentAIDecision,
  RequestAgentSandboxSubmit,
  SuccessAgentSandboxSubmit,
  FailureAgentSandboxSubmit,
  RequestDetectionSandboxTasks,
  SuccessDetectionSandboxTasks,
  FailureDetectionSandboxTasks,
  RequestAgentSandboxTasks,
  SuccessAgentSandboxTasks,
  FailureAgentSandboxTasks,
  RequestCancelAgentSandboxTask,
  SuccessCancelAgentSandboxTask,
  FailureCancelAgentSandboxTask,
} from "../actions/integrationsActions";
import { customFormData } from "../../utils/customFormData";
import { addNotification } from "../actions/notifierActions";

export function* deployInt({ payload: intname }) {
  try {
    const response = yield axiosApi.get(`/api/kubernetes/deployintegration/${intname}`, {
      timeout: 400000,
    });
    yield delay(3000);
    yield call(checkConfig);
    yield put(SuccessDeployInt(response?.data));
    yield put(
      addNotification({ message: response?.data.message, options: { variant: "success" } }),
    );
  } catch (error) {
    yield put(FailureDeployInt("Deployment failed"));
    yield put(addNotification({ message: "Deployment failed", options: { variant: "error" } }));
  }
}

export function* deleteInt({ payload: intname }) {
  try {
    const response = yield axiosApi.get(`/api/kubernetes/deleteintegration/${intname}`);
    yield delay(5000);
    yield call(checkConfig);
    yield put(SuccessDeleteInt(response?.data));
    yield put(
      addNotification({ message: response?.data.message, options: { variant: "success" } }),
    );
  } catch (error) {
    yield put(FailureDeleteInt(error));
    yield put(addNotification({ message: "Error", options: { variant: "error" } }));
  }
}

export function* setConfig({ payload: data }) {
  const formData = customFormData(data.appname);
  formData.append("name", data.appname);
  formData.append("config", data.config);
  try {
    const requestApi =
      data.appname === "phishbox" ? "/api/kubernetes/setconfig" : "/api/kubernetes/addconfig";
    const response = yield axiosApi.post(requestApi, formData);
    yield put(SuccessSetConfig("Success"));
    if (data.type !== "update") {
      yield put(
        addNotification({ message: response?.data.message, options: { variant: "success" } }),
      );
    }
    if (data.appname === "phishbox") {
      yield call(getConfig, { payload: data.appname });
    }
  } catch (error) {
    yield put(FailureSetConfig(error));
    yield put(
      addNotification({ message: error.response?.data.message, options: { variant: "error" } }),
    );
  }
}

export function* resetConfig({ payload: data }) {
  const formData = customFormData(data.appname);
  formData.append("name", data.appname);
  if (data.section) {
    formData.append("section", data.section);
  }
  try {
    const response = yield axiosApi.post("/api/kubernetes/resetconfig", formData);
    yield put(SuccessResetConfig("Success"));
    yield call(getConfig, { payload: data.appname });
    yield put(
      addNotification({ message: response?.data.message, options: { variant: "success" } }),
    );
  } catch (error) {
    yield put(FailureResetConfig(error));
    yield put(
      addNotification({ message: error.response?.data.message, options: { variant: "error" } }),
    );
  }
}

// Disabling the phishbox LLM is saved right away, enabling goes through setConfig
// (same as toggleLlmSettings for the LLM settings page).
export function* togglePhishboxLlm({ payload: { active } }) {
  try {
    const response = yield call(axiosApi.post, "/api/kubernetes/phishboxllmtoggle", { active });
    yield put(SuccessTogglePhishboxLlm());
    yield call(getConfig, { payload: "phishbox" });
    yield put(
      addNotification({
        message: response?.data?.message || "LLM disabled",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureTogglePhishboxLlm());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to change LLM status",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getConfig({ payload: intname }) {
  try {
    const response = yield axiosApi.get(`/api/kubernetes/configview/${intname}`);
    yield put(SuccessGetConfig(response?.data));
  } catch (error) {
    yield put(FailureGetConfig(error));
  }
}

export function* checkConfig() {
  try {
    const response = yield axiosApi.get("/api/kubernetes/checkconfig");
    yield put(SuccessCheckConfig(response?.data));
  } catch (error) {
    yield put(FailureCheckConfig(error));
  }
}

export function* deleteConfig({ payload: data }) {
  const jsondata = {
    intname: data.inttype,
    mountpoint: data.mountpoint,
  };

  try {
    const response = yield axiosApi.delete("/api/kubernetes/deleteconfig", { data: jsondata });
    yield put(SuccessDeleteConfig("Success"));
    if (data.type !== "update") {
      yield call(getConfig, { payload: data.inttype });

      yield put(
        addNotification({ message: response?.data.message, options: { variant: "success" } }),
      );
    }
  } catch (error) {
    yield put(FailureDeleteConfig(error));
    yield put(
      addNotification({ message: error.response?.data.message, options: { variant: "error" } }),
    );
  }
}

export function* updateConfig({ payload: data }) {
  try {
    yield call(deleteConfig, {
      payload: { inttype: data.appname, mountpoint: data.mountpoint, type: "update" },
    });
    yield call(setConfig, {
      payload: { appname: data.appname, config: data.config, type: "update" },
    });
    yield put(SuccessUpdateConfig("Success"));
    yield put(addNotification({ message: "Config Updated", options: { variant: "success" } }));
  } catch (error) {
    yield put(FailureUpdateConfig(error));
    yield put(addNotification({ message: "Config Updated Failed", options: { variant: "error" } }));
  }
}

export function* agentStatus() {
  try {
    const response = yield axiosApi.get("/api/agent/list");
    yield put(SuccessAgentStatus(response?.data?.agents));
  } catch (error) {
    yield put(FailureAgentStatus(error));
  }
}

export function* agentInstallationList({ payload }) {
  const { lastUpdatedTimeFilter } = payload;

  try {
    const response = yield axiosApi.get(
      lastUpdatedTimeFilter
        ? `/api/agent/list?filterByLastSeen=${lastUpdatedTimeFilter.id}`
        : "/api/agent/list",
    );
    yield put(
      SuccessAgentInstallationList(
        response?.data?.agents
          ? response.data.agents.sort((a, b) => b.createTime.localeCompare(a.createTime))
          : [],
      ),
    );
  } catch (error) {
    yield put(FailureAgentInstallationList(error?.message || "Something Went Wrong"));
  }
}

// Re-fetches the installation list with whatever time filter the table last stored.
function* refreshAgentInstallationList() {
  let parsedData = {};
  const storedData = localStorage.getItem("agentInstallation");
  if (storedData) {
    parsedData = JSON.parse(storedData);
  }
  yield call(agentInstallationList, { payload: { lastUpdatedTimeFilter: parsedData } });
}

// export function* allAgentsThreatHunter() {
//   try {
//     const response = yield axiosApi.get("/api/agent/thunterdata");
//     if (
//       "data" in response &&
//       "data" in response.data &&
//       "hits" in response.data.data &&
//       "hits" in response.data.data.hits
//     ) {
//       yield put(SuccessAllAgentsThreatHunter(response.data.data.hits.hits));
//     } else {
//       yield put(SuccessAllAgentsThreatHunter([]));
//     }
//   } catch (error) {
//     yield put(FaliureAllAgentsThreatHunter(error));
//   }
// }

export function* singleAgentDataThunter({ payload }) {
  const { clientID, cpuID, hostname, macAddress } = payload;

  try {
    const response = yield axiosApi.get(
      `/api/agent/thunter-scan-result?${clientID ? "uid=" + clientID + "&" : ""}${
        cpuID ? "cpuID=" + cpuID + "&" : ""
      }${hostname ? "hostname=" + hostname + "&" : ""}${
        macAddress ? "macAddress=" + macAddress : ""
      }`,
    );
    // if (
    //   "data" in response &&
    //   "data" in response.data &&
    //   "hits" in response.data.data &&
    //   "hits" in response.data.data.hits
    // ) {
    //   yield put(SuccessSingleAgentDataThunter(response.data.data.hits.hits));
    // } else {
    //   yield put(SuccessSingleAgentDataThunter("deneme"));
    // }
    yield put(SuccessSingleAgentDataThunter(response?.data?.reports || []));
  } catch (error) {
    yield put(FaliureSingleAgentDataThunter(error));
  }
}

export function* singleAgentIocResults({ payload }) {
  try {
    const response = yield axiosApi.get("/api/agent/ioc-results", { params: payload });
    yield put(SuccessSingleAgentIocResults(response?.data?.ioc_results || []));
  } catch (error) {
    yield put(FailureSingleAgentIocResults());
  }
}

export function* createNewAgent({ payload }) {
  const { clientID, serverIp, clientDesc, os } = payload;
  try {
    const response = yield axiosApi.post("/api/agent/download-url", {
      clientID,
      serverIp,
      clientDesc,
      os,
    });
    if ("data" in response && "url" in response["data"]) {
      yield put(SuccessCreateNewAgent(response.data.url));
    } else {
      yield put(SuccessCreateNewAgent(""));
    }

    let parsedData = {};
    const storedData = localStorage.getItem("agentInstallation");
    if (storedData) {
      parsedData = JSON.parse(storedData);
    }

    yield call(agentInstallationList, { payload: { lastUpdatedTimeFilter: parsedData } });
  } catch (error) {
    if ("response" in error && "data" in error.response && "message" in error.response.data) {
      yield put(FailureCreateNewAgent(error.response.data.message));
    } else {
      yield put(FailureCreateNewAgent("Something went wrong!"));
    }
  }
}

export function* analyzeAgent({ payload }) {
  const { clientID, cpuID, hostname, macAddress } = payload;
  try {
    const response = yield axiosApi.post("/api/agent/scan-request", {
      clientID,
      cpuID,
      hostname,
      macAddress,
    });
    yield put(SuccessAnalyzeAgent());
    yield put(
      addNotification({
        message: response?.data?.message
          ? response?.data?.message
          : "Analysis Request Has Been Saved for the Agent",
        options: { variant: "success" },
      }),
    );

    let parsedData = {};
    const storedData = localStorage.getItem("agentInstallation");
    if (storedData) {
      parsedData = JSON.parse(storedData);
    }
    yield call(agentInstallationList, { payload: { lastUpdatedTimeFilter: parsedData } });
  } catch (error) {
    yield put(FailureAnalyzeAgent(error.response?.data?.message));
    yield put(
      addNotification({
        message: error.response?.data?.message
          ? error.response?.data?.message
          : "Analysis Request Failed!",
        options: { variant: "error" },
      }),
    );
  }
}

export function* yaraScanAgent({ payload }) {
  const { clientID, cpuID, hostname, macAddress } = payload;
  try {
    const response = yield axiosApi.post("/api/agent/yara-scan-request", {
      clientID,
      cpuID,
      hostname,
      macAddress,
    });
    yield put(SuccessYaraScanAgent());
    yield put(
      addNotification({
        message: response?.data?.message
          ? response?.data?.message
          : "Yara Scan Request Has Been Saved for the Agent",
        options: { variant: "success" },
      }),
    );

    let parsedData = {};
    const storedData = localStorage.getItem("agentInstallation");
    if (storedData) {
      parsedData = JSON.parse(storedData);
    }
    yield call(agentInstallationList, { payload: { lastUpdatedTimeFilter: parsedData } });
  } catch (error) {
    yield put(FailureYaraScanAgent(error.response?.data?.message));
    yield put(
      addNotification({
        message: error.response?.data?.message
          ? error.response?.data?.message
          : "Yara Scan Request Failed!",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getAgentAnalysisData({ payload }) {
  const { originalID } = payload;

  try {
    const response = yield axiosApi.get(`/api/agent/analysis-report/${originalID}`);

    yield put(SuccessAgentAnalysisData(response?.data?.report || {}));
  } catch (error) {
    if ("response" in error && "data" in error.response && "message" in error.response.data) {
      yield put(FailureAgentAnalysisData(error.response.data.message));
    } else {
      yield put(FailureAgentAnalysisData("Something went wrong!"));
    }
  }
}

export function* agentSigmaOutput({ payload }) {
  const { originalId, ruleKey } = payload;

  try {
    const response = yield axiosApi.get(
      `/api/agent/analysis-report/${originalId}/sigma-output/${ruleKey}`,
    );
    yield put(SuccessAgentSigmaOutput(response?.data?.xoutput || []));
  } catch (error) {
    yield put(FailureAgentSigmaOutput());
  }
}

export function* agentProcessSnapshot({ payload }) {
  const { originalId } = payload;

  try {
    const response = yield axiosApi.get(
      `/api/agent/analysis-report/${originalId}/process-snapshot`,
    );
    yield put(SuccessAgentProcessSnapshot(response?.data || {}));
  } catch (error) {
    yield put(FailureAgentProcessSnapshot());
  }
}

export function* updateAgentDescription({ payload }) {
  const { agentId, newDescription } = payload;

  try {
    const response = yield axiosApi.post("/api/agent/updateDescription", {
      agentId,
      newDescription,
    });

    yield put(SuccessUpdateAgentDescription("Success"));
    yield put(
      addNotification({ message: response?.data.message, options: { variant: "success" } }),
    );
    yield call(agentStatus);
  } catch (error) {
    yield put(FailureUpdateAgentDescription(error));
    yield put(
      addNotification({ message: error.response?.data.message, options: { variant: "error" } }),
    );
  }
}

export function* deleteAgentRecord({ payload: id }) {
  try {
    yield axiosApi.delete(`/api/agent/delete-agent/${id}`);
    yield put(SuccessDeleteAgentRecord());
    yield put(
      addNotification({
        message: "Agent record deleted successfully",
        options: { variant: "success" },
      }),
    );

    let parsedData = {};
    const storedData = localStorage.getItem("agentInstallation");
    if (storedData) {
      parsedData = JSON.parse(storedData);
    }
    yield call(agentInstallationList, { payload: { lastUpdatedTimeFilter: parsedData } });
  } catch (error) {
    yield put(FailureDeleteAgentRecord());
    yield put(
      addNotification({
        message:
          error.response?.status === 403 ? error.response?.data.message : "Delete record failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* agentGroups({ payload: host }) {
  try {
    const response = yield axiosApi.get(`/api/agent/groups/${host}`);
    yield put(SuccessAgentGroups(response.data));
  } catch (e) {
    yield put(FailureAgentGroups());
  }
}

export function* allAgentGroups() {
  try {
    const response = yield axiosApi.get("/api/agent/groups-all");
    yield put(SuccessAllAgentGroups(response.data));
  } catch (e) {
    yield put(FailureAllAgentGroups());
  }
}

export function* bulkAnalyzeAgents({ payload }) {
  const { agentIds } = payload;
  try {
    const response = yield axiosApi.post("/api/agent/scan-request/bulk", { agentIds });
    yield put(SuccessBulkAnalyzeAgents());
    yield put(
      addNotification({
        message: response?.data?.message
          ? response.data.message
          : "Analysis Request Has Been Saved for the Agents",
        options: { variant: "success" },
      }),
    );

    yield call(refreshAgentInstallationList);
  } catch (error) {
    yield put(FailureBulkAnalyzeAgents(error.response?.data?.message));
    yield put(
      addNotification({
        message: error.response?.data?.message
          ? error.response.data.message
          : "Analysis Request Failed!",
        options: { variant: "error" },
      }),
    );
  }
}

export function* bulkYaraScanAgents({ payload }) {
  const { agentIds } = payload;
  try {
    const response = yield axiosApi.post("/api/agent/yara-scan-request/bulk", { agentIds });
    yield put(SuccessBulkYaraScanAgents());
    yield put(
      addNotification({
        message: response?.data?.message
          ? response.data.message
          : "Yara Scan Request Has Been Saved for the Agents",
        options: { variant: "success" },
      }),
    );

    yield call(refreshAgentInstallationList);
  } catch (error) {
    yield put(FailureBulkYaraScanAgents(error.response?.data?.message));
    yield put(
      addNotification({
        message: error.response?.data?.message
          ? error.response.data.message
          : "Yara Scan Request Failed!",
        options: { variant: "error" },
      }),
    );
  }
}

export function* bulkDeleteAgents({ payload }) {
  const { agentIds } = payload;
  try {
    const response = yield axiosApi.post("/api/agent/delete-agent/bulk", { agentIds });
    yield put(SuccessBulkDeleteAgents());
    yield put(
      addNotification({
        message: response?.data?.message
          ? response.data.message
          : "Agent records deleted successfully",
        options: { variant: "success" },
      }),
    );

    yield call(refreshAgentInstallationList);
  } catch (error) {
    yield put(FailureBulkDeleteAgents());
    yield put(
      addNotification({
        message:
          error.response?.status === 403 ? error.response?.data.message : "Delete records failed",
        options: { variant: "error" },
      }),
    );
  }
}

export function* createAgentGroup({ payload }) {
  const { host, ...reqBody } = payload;
  try {
    yield axiosApi.post(`/api/agent/groups/${host}`, reqBody);
    yield put(SuccessCreateAgentGroup());
    yield call(agentGroups, { payload: host });
    yield put(
      addNotification({
        message: "Agent group created successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureCreateAgentGroup());
    yield put(
      addNotification({
        message: "Failed to create agent group",
        options: { variant: "error" },
      }),
    );
  }
}

export function* deleteAgentGroup({ payload }) {
  const { id, host } = payload;
  try {
    yield axiosApi.delete(`/api/agent/groups/${id}/${host}`);
    yield put(SuccessDeleteAgentGroup());
    yield call(agentGroups, { payload: host });
    yield put(
      addNotification({
        message: "Agent group deleted successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureDeleteAgentGroup());
    yield put(
      addNotification({
        message: "Failed to delete agent group",
        options: { variant: "error" },
      }),
    );
  }
}

export function* agentPolicies({ payload: host }) {
  try {
    const response = yield axiosApi.get(`/api/agent/policies/${host}`);
    yield put(SuccessAgentPolicies(response.data));
  } catch (e) {
    yield put(FailureAgentPolicies());
  }
}

export function* createAgentPolicy({ payload }) {
  const { host, onSuccess, ...reqBody } = payload;
  try {
    yield axiosApi.post(`/api/agent/policies/${host}`, reqBody);
    yield put(SuccessCreateAgentPolicy());
    yield call(agentPolicies, { payload: host });
    yield put(
      addNotification({
        message: "Agent policy created successfully",
        options: { variant: "success" },
      }),
    );
    if (onSuccess) onSuccess();
  } catch (e) {
    yield put(FailureCreateAgentPolicy());
    yield put(
      addNotification({
        message: e?.response?.data?.message || "Failed to create agent policy",
        options: { variant: "error" },
      }),
    );
  }
}

export function* agentPolicy({ payload }) {
  const { id, host } = payload;
  try {
    const response = yield axiosApi.get(`/api/agent/policies/${id}/${host}`);
    yield put(SuccessAgentPolicy(response.data));
  } catch (e) {
    yield put(FailureAgentPolicy());
  }
}

export function* moveAgentPolicy({ payload }) {
  const { id, direction, host } = payload;
  try {
    yield axiosApi.post(`/api/agent/policies/${id}/move/${host}`, { direction });
    yield put(SuccessMoveAgentPolicy());
    yield call(agentPolicies, { payload: host });
    // yield put(
    //   addNotification({
    //     message: "Agent policy moved successfully",
    //     options: { variant: "success" },
    //   }),
    // );
  } catch (e) {
    yield put(FailureMoveAgentPolicy());
    yield put(
      addNotification({
        message: "Failed to move agent policy",
        options: { variant: "error" },
      }),
    );
  }
}

export function* updateAgentPolicy({ payload }) {
  const { id, host, onSuccess, ...reqBody } = payload;
  try {
    yield axiosApi.put(`/api/agent/policies/${id}/${host}`, reqBody);
    yield put(SuccessUpdateAgentPolicy());
    yield call(agentPolicy, { payload: { id, host } });
    yield put(
      addNotification({
        message: "Agent policy updated successfully",
        options: { variant: "success" },
      }),
    );
    if (onSuccess) {
      onSuccess();
    }
  } catch (e) {
    yield put(FailureUpdateAgentPolicy());
    yield put(
      addNotification({
        message: "Failed to update agent policy",
        options: { variant: "error" },
      }),
    );
  }
}

export function* deleteAgentPolicy({ payload }) {
  const { id, host } = payload;
  try {
    const response = yield axiosApi.delete(`/api/agent/policies/${id}/${host}`);
    yield put(SuccessDeleteAgentPolicy(response.data));
    yield call(agentPolicies, { payload: host });
    yield put(
      addNotification({
        message: "Agent policy deleted successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureDeleteAgentPolicy());
    yield put(
      addNotification({
        message: "Failed to delete agent policy",
        options: { variant: "error" },
      }),
    );
  }
}

export function* resetAgentPolicy({ payload }) {
  const { id, host, onFinish } = payload;
  try {
    yield axiosApi.post(`/api/agent/policies/${id}/reset/${host}`);
    yield put(SuccessResetAgentPolicy());
    yield call(agentPolicy, { payload: { id, host } });
    yield put(
      addNotification({
        message: "Agent policy reset successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureResetAgentPolicy());
    yield put(
      addNotification({
        message: "Failed to reset agent policy",
        options: { variant: "error" },
      }),
    );
  } finally {
    onFinish();
  }
}

export function* repairAgentPolicy({ payload }) {
  const { id, host, onFinish } = payload;
  try {
    yield axiosApi.post(`/api/agent/policies/${id}/repair/${host}`);
    yield put(SuccessRepairAgentPolicy());
    yield call(agentPolicy, { payload: { id, host } });
    yield put(
      addNotification({
        message: "Agent policy repaired successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureRepairAgentPolicy());
    yield put(
      addNotification({
        message: "Failed to repair agent policy",
        options: { variant: "error" },
      }),
    );
  } finally {
    onFinish();
  }
}

export function* distinctLiveThreatHunters() {
  try {
    const response = yield axiosApi.get("/api/agent/live-hosts");
    yield put(SuccessDistinctLiveThreatHunters(response.data));
  } catch (e) {
    yield put(FailureDistinctLiveThreatHunters());
  }
}

export function* tapInterfaces() {
  try {
    const response = yield axiosApi.get("/api/kubernetes/gettapinterfaces");
    const data = response?.data?.interfaces || [];
    const mappedData = data.map((item) => ({ id: item, value: item }));
    yield put(SuccessTapInterfaces(mappedData));
  } catch (e) {
    yield put(FailureTapInterfaces());
  }
}

export function* hunterBoxList({ payload }) {
  const activeTab = yield select((state) => state.integrations.hunterBoxActiveTab);

  const { selectedTimeFilter, pageSize, pageNumber, source, filters = [] } = payload;

  try {
    const query = new URLSearchParams({
      filterByLast: selectedTimeFilter?.id,
      pageNumber,
      pageSize,
      malicious: activeTab === "Malicious",
      ...(source && { source }),
      ...Object.fromEntries(filters.map((f) => [f.id, f.value])),
    });

    const response = yield axiosApi.get(`/api/agent/hunter-box/list?${query.toString()}`, {
      timeout: 12000,
    });
    yield put(SuccessHunterBoxList(response?.data));
  } catch (error) {
    yield put(FailureHunterBoxList(error));
  }
}

export function* yaraResultsList({ payload }) {
  const activeTab = yield select((state) => state.integrations.yaraResultsActiveTab);
  const { selectedTimeFilter, pageSize, pageNumber, filters = [] } = payload;

  try {
    const query = new URLSearchParams({
      groupBy: activeTab === "Group by Host" ? "host" : "rule",
      filterByLast: selectedTimeFilter?.id,
      pageNumber,
      pageSize,
      ...Object.fromEntries(filters.map((filter) => [filter.id, filter.value])),
    });

    const response = yield axiosApi.get(`/api/agent/yara-scan/list?${query.toString()}`, {
      timeout: 12000,
    });

    yield put(SuccessYaraResultsList(response?.data));
  } catch (error) {
    yield put(FailureYaraResultsList(error));
  }
}

export function* hunterBoxStats({ payload }) {
  try {
    const response = yield axiosApi.get("/api/agent/hunter-box/stats");
    yield put(SuccessHunterBoxStats(response?.data));
  } catch (error) {
    yield put(FailureHunterBoxStats(error));
  }
}

export function* threatHunterDashboard({ payload: { filterByLast } }) {
  let tz;
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    tz = undefined;
  }
  try {
    const response = yield call(axiosApi.get, "/api/agent/threat-hunter/dashboard", {
      params: { filterByLast, tz },
    });
    yield put(SuccessThreatHunterDashboard(response.data));
  } catch (error) {
    yield put(FailureThreatHunterDashboard());
  }
}

export function* threatHunterSubmit({ payload }) {
  const { file, onSuccess } = payload;
  try {
    const formData = customFormData({});
    formData.append("file", file);
    yield axiosApi.post("/api/files/thuntersubmit-ui", formData);
    onSuccess();
    yield put(SuccessThreatHunterSubmit());
    yield put(addNotification({ message: "Submitted file", options: { variant: "success" } }));
  } catch (e) {
    yield put(FailureThreatHunterSubmit());
  }
}

export function* agentSandboxSubmit({ payload }) {
  const { originalID, filePath, sha256, options } = payload;
  try {
    const response = yield axiosApi.post("/api/agent/sandbox-submit-request", {
      originalID,
      filePath,
      sha256,
      options,
    });
    yield put(SuccessAgentSandboxSubmit());

    const hostname = response?.data?.hostname || "the machine";
    yield put(
      addNotification({
        message: response?.data?.agentOnline
          ? `Request queued. The file will be collected from ${hostname} in about a minute and submitted to the sandbox.`
          : `${hostname} is offline. The request is queued and will run automatically when the agent comes online (valid for 7 days).`,
        options: { variant: response?.data?.agentOnline ? "success" : "info" },
      }),
    );
    yield call(detectionSandboxTasks, { payload: { originalID, sha256 } });
  } catch (error) {
    yield put(FailureAgentSandboxSubmit());
    yield put(
      addNotification({
        message: error.response?.data?.message || "Sandbox request failed!",
        options: { variant: "error" },
      }),
    );
  }
}

export function* detectionSandboxTasks({ payload }) {
  const { originalID, sha256 } = payload;
  try {
    const query = new URLSearchParams({ originalID, sha256, pageSize: 5 });
    const response = yield axiosApi.get(`/api/agent/tasks?${query.toString()}`);
    yield put(SuccessDetectionSandboxTasks({ sha256, tasks: response?.data?.tasks }));
  } catch (error) {
    yield put(FailureDetectionSandboxTasks({ sha256 }));
  }
}

export function* agentSandboxTasks({ payload }) {
  const { agentId, pageNumber = 1, pageSize = 20 } = payload;
  try {
    const query = new URLSearchParams({ agentId, pageNumber, pageSize });
    const response = yield axiosApi.get(`/api/agent/tasks?${query.toString()}`);
    yield put(SuccessAgentSandboxTasks(response?.data));
  } catch (error) {
    yield put(FailureAgentSandboxTasks());
  }
}

export function* cancelAgentSandboxTask({ payload }) {
  const { taskId, onSuccess } = payload;
  try {
    const response = yield axiosApi.post(`/api/agent/tasks/${taskId}/cancel`);
    yield put(SuccessCancelAgentSandboxTask());
    yield put(
      addNotification({
        message: response?.data?.message || "Sandbox request cancelled",
        options: { variant: "success" },
      }),
    );
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(FailureCancelAgentSandboxTask());
    yield put(
      addNotification({
        message: error.response?.data?.message || "Cancelling sandbox request failed!",
        options: { variant: "error" },
      }),
    );
  }
}

export function* generateAgentAIDecision({ payload: id }) {
  try {
    yield call(axiosApi.post, `/api/aichat/agent/generate-ai-decision/${id}`);
    yield put(SuccessGenerateAgentAIDecision());
    yield call(getAgentAIDecision, { payload: id });
    yield put(
      addNotification({
        message: "Generated agent ai decision successfully",
        options: { variant: "success" },
      }),
    );
  } catch (e) {
    yield put(FailureGenerateAgentAIDecision());
    yield put(
      addNotification({
        message: "Failed to generate agent ai decision",
        options: { variant: "error" },
      }),
    );
  }
}

export function* getAgentAIDecision({ payload: id }) {
  try {
    const response = yield call(
      axiosApi.get,
      `/api/agent/analysis-report/generated-ai-decision/${id}`,
    );
    yield put(SuccessGetAgentAIDecision(response.data.ai_decision));
  } catch (e) {
    yield put(FailureGetAgentAIDecision());
  }
}

const integrationsSagas = [
  takeEvery(RequestDeployInt, deployInt),
  takeEvery(RequestGetConfig, getConfig),
  takeEvery(RequestDeleteInt, deleteInt),
  takeEvery(RequestSetConfig, setConfig),
  takeEvery(RequestResetConfig, resetConfig),
  takeEvery(RequestTogglePhishboxLlm, togglePhishboxLlm),
  takeEvery(RequestUpdateConfig, updateConfig),
  takeEvery(RequestCheckConfig, checkConfig),
  takeEvery(RequestDeleteConfig, deleteConfig),
  takeEvery(RequestAgentStatus, agentStatus),
  takeEvery(RequestAgentInstallationList, agentInstallationList),
  // takeEvery(RequestAllAgentsThreatHunter, allAgentsThreatHunter),
  takeEvery(RequestSingleAgentDataThunter, singleAgentDataThunter),
  takeEvery(RequestSingleAgentIocResults, singleAgentIocResults),
  takeEvery(RequestCreateNewAgent, createNewAgent),
  takeEvery(RequestAnalyzeAgent, analyzeAgent),
  takeEvery(RequestYaraScanAgent, yaraScanAgent),
  takeEvery(RequestAgentAnalysisData, getAgentAnalysisData),
  takeLatest(RequestAgentSigmaOutput, agentSigmaOutput),
  takeLatest(RequestAgentProcessSnapshot, agentProcessSnapshot),
  takeEvery(RequestUpdateAgentDescription, updateAgentDescription),
  takeEvery(RequestDeleteAgentRecord, deleteAgentRecord),
  takeEvery(RequestAgentGroups, agentGroups),
  takeLatest(RequestAllAgentGroups, allAgentGroups),
  takeEvery(RequestBulkAnalyzeAgents, bulkAnalyzeAgents),
  takeEvery(RequestBulkYaraScanAgents, bulkYaraScanAgents),
  takeEvery(RequestBulkDeleteAgents, bulkDeleteAgents),
  takeEvery(RequestCreateAgentGroup, createAgentGroup),
  takeEvery(RequestDeleteAgentGroup, deleteAgentGroup),
  takeEvery(RequestAgentPolicies, agentPolicies),
  takeLatest(RequestCreateAgentPolicy, createAgentPolicy),
  takeEvery(RequestAgentPolicy, agentPolicy),
  takeEvery(RequestMoveAgentPolicy, moveAgentPolicy),
  takeEvery(RequestUpdateAgentPolicy, updateAgentPolicy),
  takeEvery(RequestDeleteAgentPolicy, deleteAgentPolicy),
  takeLatest(RequestResetAgentPolicy, resetAgentPolicy),
  takeLatest(RequestRepairAgentPolicy, repairAgentPolicy),
  takeLatest(RequestDistinctLiveThreatHunters, distinctLiveThreatHunters),
  takeLatest(RequestTapInterfaces, tapInterfaces),
  takeLatest(RequestHunterBoxList, hunterBoxList),
  takeLatest(RequestHunterBoxStats, hunterBoxStats),
  takeLatest(RequestThreatHunterDashboard, threatHunterDashboard),
  takeLatest(RequestYaraResultsList, yaraResultsList),
  takeLatest(RequestThreatHunterSubmit, threatHunterSubmit),
  takeLatest(RequestGenerateAgentAIDecision, generateAgentAIDecision),
  takeLatest(RequestGetAgentAIDecision, getAgentAIDecision),
  takeLatest(RequestAgentSandboxSubmit, agentSandboxSubmit),
  takeEvery(RequestDetectionSandboxTasks, detectionSandboxTasks),
  takeLatest(RequestAgentSandboxTasks, agentSandboxTasks),
  takeLatest(RequestCancelAgentSandboxTask, cancelAgentSandboxTask),
];

export default integrationsSagas;
